// docs/mail-stats: links in our mails carry track=<token>; it is removed from the address on
// load and the app sends it to the api (POST /mail-tracking/click) with its own apiClient.
// Must be the FIRST import of <app>/index.jsx: the router's history keeps the location from
// the moment it is created (on import of <app>/store), and Sentry (replay, tracing) and gtag
// must never see the token in the page URL.
// Only `track` goes, the other parameters stay as written (no URLSearchParams, it would
// re-encode the candidate search filters).
const TRACK_PARAM_RE = /([?&])track=([A-Za-z0-9_-]+)(&?)/;

const match = window.location.search.match(TRACK_PARAM_RE);
if (match) {
  const [, separator, , ampersand] = match;
  const search = window.location.search.replace(TRACK_PARAM_RE, ampersand ? separator : '');
  const { pathname, hash } = window.location;
  window.history.replaceState(window.history.state, '', `${pathname}${search === '?' ? '' : search}${hash}`);
}

export const mailTrackToken = match ? match[2] : null;
